// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccm-likes .post-likes {
  position: relative;
}
.ccm-likes .post-likes .like-button {
  margin-bottom: 2px;
}
.ccm-likes .post-likes .like-button .mat-icon {
  font-size: 20px;
}
.ccm-likes .fi-info-icon {
  position: relative;
  height: 100%;
  vertical-align: middle;
  line-height: 40px;
  width: 20px;
  text-align: center;
  cursor: pointer;
}
.ccm-likes .fi-info-icon:not([hidden]) {
  display: inline-block;
}
.ccm-likes .fi-info-icon .info-popup {
  padding: 10px;
  min-width: unset;
  left: 50%;
  top: 0;
  transform: translate(-50%, -100%);
  border: none;
  line-height: 20px;
}
.ccm-likes .fi-info-icon .info-popup div {
  white-space: nowrap;
}
.ccm-likes .current-user-liked {
  color: #f54848 !important;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/ccm-likes/likes.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AACQ;EACI,kBAAA;AACZ;AAAY;EACI,eAAA;AAEhB;AAEI;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAEQ;EACI,qBAAA;AAAZ;AAEQ;EACI,aAAA;EACA,gBAAA;EACA,SAAA;EACA,MAAA;EACA,iCAAA;EACA,YAAA;EACA,iBAAA;AAAZ;AACY;EACI,mBAAA;AAChB;AAGI;EACI,yBAAA;AADR","sourcesContent":[".ccm-likes {\r\n    .post-likes {\r\n        position: relative;\r\n        .like-button {\r\n            margin-bottom: 2px;\r\n            .mat-icon {\r\n                font-size: 20px;\r\n            }\r\n        }\r\n    }\r\n    .fi-info-icon {\r\n        position: relative;\r\n        height: 100%;\r\n        vertical-align: middle;\r\n        line-height: 40px;\r\n        width: 20px;\r\n        text-align: center;\r\n        cursor: pointer;\r\n\r\n        &:not([hidden]) {\r\n            display: inline-block;\r\n        }\r\n        .info-popup {\r\n            padding: 10px;\r\n            min-width: unset;\r\n            left: 50%;\r\n            top: 0;\r\n            transform: translate(-50%, -100%);\r\n            border: none;\r\n            line-height: 20px;\r\n            div {\r\n                white-space: nowrap;\r\n            }\r\n        }\r\n    }\r\n    .current-user-liked {\r\n        color: #f54848 !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
